/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deck_Upload_Online_OnlyInputs */



/**
* | output |
* | --- |
* | "URL and QR import need a connection — paste a decklist to import offline." |
*
* @param {Deck_Upload_Online_OnlyInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deck_upload_online_only = /** @type {((inputs?: Deck_Upload_Online_OnlyInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deck_Upload_Online_OnlyInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'import par URL et QR nécessite une connexion — collez une liste de deck pour importer hors ligne.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La importación por URL y QR requiere conexión — pegue una lista de deck para importar sin conexión.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("A importação por URL e QR exige conexão — cole uma lista de deck para importar offline.")
	if (locale === "it") return /** @type {LocalizedString} */ ("L'importazione da URL e QR richiede una connessione — incolla una lista del deck per importare offline.")
	return /** @type {LocalizedString} */ ("URL and QR import need a connection — paste a decklist to import offline.")
});